import styled from 'styled-components';

const Container = styled.div`
  background-image: linear-gradient(20deg, #01288F, #0954B6 );
  height: 73px;
  position: relative;
  z-index: 50;
`;

export default Container;
